(() => {
  if (window.KoppaProductQuickAdd) return;

  const productPath = /\/products\/([^/?#]+)/;
  // .article-template: a journal article is an <article>, which cardSelectors
  // matches, so the whole page got an "Add +" pill in its corner. Articles
  // carry their own product cards and buttons (journal-product-offer).
  const skipWithin = 'header, footer, #menu-drawer, .koppa-mobile-menu, #product-purchase, .product__info-wrapper, .product-form, .cf-email, .science__facts, .article-template, .jpo-sticky';
  const cardSelectors = [
    '.koppa-quick-add-card',
    '.collection-product-card',
    '.card-wrapper.product-card-wrapper',
    '.ch-prod-card',
    '.kh-category',
    '[data-ploy-product-card]',
    'li.grid__item',
    // Product pages use <koppa-card> where they used <article> (2026-10-20).
    'article',
    'koppa-card'
  ];
  const productCache = new Map();
  const preorderLabel = handle => handle === 'ghk-cu-trio' ? window.koppaStockState.labels.protocolBuy : window.koppaStockState.labels.creamBuy;
  const heroStyles = new Map();
  let scheduled = false;

  function handleFrom(anchor) {
    try {
      const url = new URL(anchor.getAttribute('href') || '', location.origin);
      const match = url.pathname.match(productPath);
      return match ? decodeURIComponent(match[1]) : '';
    } catch {
      return '';
    }
  }

  function cardFor(anchor) {
    if (anchor.closest(skipWithin)) return null;
    for (const selector of cardSelectors) {
      const card = anchor.closest(selector);
      if (card && (card.matches('a[href*="/products/"]') || card.querySelector('a[href*="/products/"]'))) return card;
    }
    if (anchor.querySelector('img') && anchor.textContent.trim()) return anchor;
    return null;
  }

  async function productData(handle) {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(`/products/${handle}.js`, {headers:{Accept:'application/json'}}).then(response => {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      }));
    }
    return productCache.get(handle);
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
      bubble.hidden = false;
      const visible = bubble.querySelector('span:not(.visually-hidden)') || bubble.querySelector('span');
      if (visible) visible.textContent = count;
    });
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = count; });
  }

  async function add(handle, button) {
    if (button.disabled) return;
    if (window.koppaStockState?.preorders?.[handle]) { location.href = `/products/${handle}#product-purchase`; return; }
    const original = button.textContent;
    const drawer = document.querySelector('cart-drawer');
    let added = false;
    button.disabled = true;
    button.textContent = '...';
    try {
      const product = await productData(handle);
      const variant = product.variants.find(item => item.available) || product.variants[0];
      if (!variant || variant.available === false) {
        button.disabled = false;
        button.textContent = original;
        if (window.koppaOpenWaitlist) window.koppaOpenWaitlist({handle, name: product.title});
        else location.href = product.url;
        return;
      }
      const payload = {items:[{id:variant.id, quantity:1}]};
      if (drawer) {
        payload.sections = drawer.getSectionsToRender().map(section => section.id);
        payload.sections_url = location.pathname;
        drawer.setActiveElement(button);
      }
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json', Accept:'application/json'},
        body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error('Cart add failed');
      added = true;
      const result = await response.json();
      if (drawer) {
        const complete = drawer.getSectionsToRender().every(section => typeof result.sections?.[section.id] === 'string');
        button.disabled = false;
        drawer.classList.remove('is-empty');
        if (complete) drawer.renderContents(result);
        else {
          await drawer.refresh();
          const notice = drawer.querySelector('.kc-added');
          if (notice) notice.hidden = false;
          drawer.open();
        }
      }
      const cart = await fetch('/cart.js', {headers:{Accept:'application/json'}}).then(res => res.json()).catch(() => null);
      if (cart) updateCartCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart}}));
      button.classList.add('is-added');
      button.textContent = window.matchMedia('(max-width: 767px)').matches ? '\u2713' : 'Added';
      setTimeout(() => {
        button.disabled = false;
        button.classList.remove('is-added');
        button.textContent = original;
      }, 1600);
    } catch {
      if (added) {
        location.assign(window.routes?.cart_url || '/cart');
        return;
      }
      button.textContent = window.matchMedia('(max-width: 767px)').matches ? '!' : 'View';
      setTimeout(() => {
        button.disabled = false;
        button.textContent = original;
      }, 1600);
    }
  }

  function addButtons() {
    const fresh = [];
    document.querySelectorAll('a[href*="/products/"]').forEach(anchor => {
      const handle = handleFrom(anchor);
      if (!handle) return;
      let card = cardFor(anchor);
      if (!card || card.dataset.koppaQuickAddReady) return;
      if (card.tagName === 'A') {
        const wrapper = document.createElement('div');
        wrapper.className = card.className;
        card.before(wrapper);
        wrapper.append(card);
        card.className = 'koppa-product-card-link';
        card.style.setProperty('display', 'contents', 'important');
        const rail = wrapper.closest('[data-koppa-rail]');
        if (rail) window.KoppaCarousels?.rails.get(rail)?.destroy();
        card = wrapper;
      }
      card.dataset.koppaQuickAddReady = handle;
      card.classList.add('koppa-quick-add-card');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'koppa-quick-add-corner';
      const homeLink = card.querySelector('[data-home-sold-out]');
      const soldOut = homeLink?.dataset.homeSoldOut === 'true';
      button.textContent = window.koppaStockState?.preorders?.[handle] ? preorderLabel(handle) : (soldOut ? 'Notify +' : 'Add +');
      button.title = soldOut ? 'Join the waitlist' : 'Quick add to cart';
      if (homeLink) {
        card.dataset.homeQuickAdd = 'true';
        const cta = homeLink.querySelector('[data-home-waitlist]')?.parentElement;
        if (cta) cta.addEventListener('click', event => {
          if (!window.koppaOpenWaitlist) return;
          event.preventDefault();
          window.koppaOpenWaitlist({handle, name: homeLink.dataset.homeProductName});
        });
        const ctaRow = homeLink.querySelector('span.mt-auto');
        if (ctaRow) ctaRow.style.setProperty('max-width', 'calc(100% - 82px)');
      }
      button.setAttribute('aria-label', `${soldOut ? 'Join waitlist for' : 'Quick add'} ${homeLink?.dataset.homeProductName || card.querySelector('h3, [data-ploy-heading]')?.textContent.trim() || handle.replaceAll('-', ' ')}`);
      // No transition until the inline styles below have been computed once:
      // otherwise the first layout sees the stylesheet colours, the inline ones
      // then land, and the colour/border change animates on load (PageSpeed
      // "non-composited animations", 2026-09-30).
      button.style.setProperty('transition', 'none', 'important');
      fresh.push(button);
      button.addEventListener('pointerdown', event => event.stopPropagation());
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        add(handle, button);
      });
      card.append(button);
    });
    styleQuickAddButtons();
    if (fresh.length) requestAnimationFrame(() => requestAnimationFrame(() => {
      fresh.forEach(button => button.style.removeProperty('transition'));
    }));
  }

  function styleQuickAddButtons() {
    const mobile = window.matchMedia('(max-width: 767px)').matches;
    const buttons = [...document.querySelectorAll('.koppa-quick-add-corner')];
    // Measure every card before writing any style. Reading geometry inside the
    // write loop forced one synchronous layout per button (PageSpeed
    // 2026-09-30: 223 ms on mobile). The button is absolutely positioned, so
    // its own styles never move the card or its media.
    const offsets = new Map();
    buttons.forEach(button => {
      const card = button.closest('.koppa-quick-add-card');
      if (!mobile && !card.closest('#products')) return;
      const media = card.querySelector('.ploy-product-media, .collection-product-card__media, .card__inner') || card.querySelector('img');
      const cardRect = card.getBoundingClientRect();
      const mediaRect = media?.getBoundingClientRect();
      offsets.set(button, {
        top: mediaRect ? mediaRect.top - cardRect.top + 10 : 10,
        lowerTop: mediaRect ? mediaRect.bottom - cardRect.top - 50 : 10,
        right: mediaRect ? cardRect.right - mediaRect.right + 10 : 10
      });
    });
    document.querySelectorAll('.koppa-quick-add-card').forEach(card => {
      setImportant(card, 'position', 'relative');
    });
    buttons.forEach(button => {
      setImportant(button, 'position', 'absolute');
      const homeCard = button.closest('[data-home-quick-add]');
      const mobileShopAll = mobile && button.closest('[data-ploy-page="shop-all"] .collection-product-card');
      setImportant(button, 'top', homeCard ? 'auto' : '10px');
      setImportant(button, 'bottom', homeCard ? '20px' : 'auto');
      setImportant(button, 'right', homeCard ? '20px' : '10px');
      setImportant(button, 'z-index', '50');
      setImportant(button, 'display', 'inline-flex');
      setImportant(button, 'align-items', 'center');
      setImportant(button, 'justify-content', 'center');
      setImportant(button, 'width', 'auto');
      setImportant(button, 'max-width', 'max-content');
      setImportant(button, 'min-width', mobile ? '52px' : '58px');
      setImportant(button, 'height', 'auto');
      setImportant(button, 'min-height', mobile ? '44px' : '36px');
      setImportant(button, 'padding', '0 12px');
      setImportant(button, 'border', '1px solid rgb(7 24 51 / 18%)');
      setImportant(button, 'border-radius', '0');
      setImportant(button, 'background', homeCard ? '#071833' : 'rgb(247 248 251 / 94%)');
      setImportant(button, 'color', homeCard ? '#ffffff' : '#071833');
      setImportant(button, 'box-shadow', '0 8px 20px rgb(7 24 51 / 14%)');
      setImportant(button, 'font', '600 12px/1.1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif');
      setImportant(button, 'letter-spacing', '.01em');
      setImportant(button, 'text-transform', 'none');
      setImportant(button, 'text-decoration', 'none');
      setImportant(button, 'cursor', button.disabled ? 'default' : 'pointer');
      if (mobile) {
        const card = button.closest('.koppa-quick-add-card');
        const {top, lowerTop, right} = offsets.get(button);
        setImportant(button, 'top', `${Math.max(6, mobileShopAll ? lowerTop : top)}px`);
        setImportant(button, 'bottom', 'auto');
        setImportant(button, 'right', `${Math.max(10, right)}px`);
        setImportant(button, 'width', '44px');
        setImportant(button, 'height', '44px');
        setImportant(button, 'min-width', '44px');
        setImportant(button, 'min-height', '44px');
        setImportant(button, 'padding', '0');
        setImportant(button, 'border-radius', '0');
        setImportant(button, 'background', 'transparent');
        setImportant(button, 'border', '1px solid rgb(255 255 255 / 24%)');
        setImportant(button, 'backdrop-filter', 'blur(12px) brightness(.72)');
        setImportant(button, '-webkit-backdrop-filter', 'blur(12px) brightness(.72)');
        setImportant(button, 'color', '#fff');
        setImportant(button, 'text-shadow', '0 1px 3px rgb(0 0 0 / 65%)');
        setImportant(button, 'box-shadow', 'none');
        setImportant(button, 'font-size', '20px');
        setImportant(button, 'font-weight', '300');
        setImportant(button, 'letter-spacing', '0');
        const handle = card.dataset.koppaQuickAddReady;
        const mobileLabel = !mobileShopAll && window.koppaStockState?.preorders?.[handle] ? preorderLabel(handle) : '+';
        if (!button.disabled && button.textContent !== mobileLabel) button.textContent = mobileLabel;
      } else {
        button.style.removeProperty('backdrop-filter');
        button.style.removeProperty('-webkit-backdrop-filter');
        button.style.removeProperty('text-shadow');
        if (!button.disabled && button.textContent === '+') button.textContent = button.title === 'Join the waitlist' ? 'Notify +' : 'Add +';
      }
      const preorderHandle = button.closest('.koppa-quick-add-card')?.dataset.koppaQuickAddReady;
      if (!mobileShopAll && window.koppaStockState?.preorders?.[preorderHandle]) {
        setImportant(button, 'width', 'auto');
        setImportant(button, 'height', 'auto');
        setImportant(button, 'max-width', 'calc(100% - 20px)');
        setImportant(button, 'padding', '10px 12px');
        setImportant(button, 'font-size', '11px');
        setImportant(button, 'line-height', '1.3');
        setImportant(button, 'font-weight', '600');
        if (homeCard && !mobile) {
          setImportant(button, 'top', '10px');
          setImportant(button, 'bottom', 'auto');
        }
      }
      if (!mobile && homeCard && homeCard.closest('#products')) {
        const {lowerTop, right} = offsets.get(button);
        setImportant(button, 'top', `${Math.max(6, lowerTop - 6)}px`);
        setImportant(button, 'bottom', 'auto');
        setImportant(button, 'right', `${Math.max(12, right + 4)}px`);
        setImportant(button, 'height', '42px');
        setImportant(button, 'min-height', '42px');
        setImportant(button, 'padding', '0 16px');
        setImportant(button, 'border-radius', '0');
        setImportant(button, 'border', '1px solid rgb(255 255 255 / 48%)');
        setImportant(button, 'background', 'rgb(255 255 255 / 12%)');
        setImportant(button, 'backdrop-filter', 'blur(14px) brightness(.68)');
        setImportant(button, '-webkit-backdrop-filter', 'blur(14px) brightness(.68)');
        setImportant(button, 'color', '#fff');
        setImportant(button, 'text-shadow', '0 1px 3px rgb(0 0 0 / 45%)');
        setImportant(button, 'box-shadow', 'inset 0 1px 0 rgb(255 255 255 / 12%)');
        setImportant(button, 'font-weight', '500');
      }
      if (mobileShopAll) {
        setImportant(button, 'background', 'linear-gradient(#071833, #071833) center / 36px 36px no-repeat');
        setImportant(button, 'border', '0');
        setImportant(button, 'backdrop-filter', 'none');
        setImportant(button, '-webkit-backdrop-filter', 'none');
        setImportant(button, 'text-shadow', 'none');
      }
    });
  }





  function setImportant(element, property, value) {
    if (element && (element.style.getPropertyValue(property) !== value || element.style.getPropertyPriority(property) !== 'important')) element.style.setProperty(property, value, 'important');
  }

  function modalOpen(dialog) {
    if (!dialog) return;
    dialog.hidden = false;
    if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
    else {
      dialog.classList.add('is-open');
      dialog.setAttribute('open', '');
    }
  }

  function modalClose(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    dialog.hidden = true;
    dialog.classList.remove('is-open');
    dialog.removeAttribute('open');
  }

  function ensureModal(id, title, body, form = '') {
    let dialog = document.getElementById(id);
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.id = id;
    dialog.className = 'koppa-ui-dialog';
    dialog.hidden = true;
    dialog.innerHTML = `
      <div class="koppa-ui-dialog__inner">
        <div class="koppa-ui-dialog__head">
          <h2 class="koppa-ui-dialog__title">${title}</h2>
          <button type="button" class="koppa-ui-dialog__close" data-koppa-dialog-close aria-label="Close">&times;</button>
        </div>
        <div class="koppa-ui-dialog__body">${body}${form}</div>
      </div>
    `;
    dialog.addEventListener('click', event => {
      if (event.target === dialog || event.target.closest('[data-koppa-dialog-close]')) modalClose(dialog);
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && (dialog.open || dialog.classList.contains('is-open'))) modalClose(dialog);
    });
    document.body.append(dialog);
    return dialog;
  }

  function productHandle() {
    const match = location.pathname.match(productPath);
    return match ? decodeURIComponent(match[1]) : document.querySelector('[data-ploy-product-handle]')?.dataset.ployProductHandle || '';
  }

  function productBenefitCopy(handle) {
    if (/trio|protocol/.test(handle)) {
      return {
        name: 'GHK-Cu Protocol',
        title: 'Three steps. Smoother, better-hydrated skin.',
        items: ['Treat with the serum, replenish with the cream, target with the balm.', 'A complete copper peptide routine without extra steps.', 'Designed to support healthier-looking skin every day.']
      };
    }
    if (/moisturizer|cream/.test(handle)) {
      return {
        name: 'GHK-Cu Capsule Cream',
        title: 'Lasting hydration. Softer, smoother skin.',
        items: ['Cushions dry-feeling skin and supports barrier comfort.', 'Capsule texture blends in without a heavy finish.', 'Helps skin feel softer, smoother and more resilient.']
      };
    }
    if (/balm|stick/.test(handle)) {
      return {
        name: 'GHK-Cu Face + Body Balm Stick',
        title: 'Dry spots. Fine lines. Targeted care.',
        items: ['Swipe directly onto dry patches, neck, hands and post-shave areas.', 'Waterless balm format keeps reapplication simple.', 'Portable copper peptide care wherever skin needs support.']
      };
    }
    return {
      name: 'GHK-Cu 2% Serum',
      title: 'Firmer-looking skin. Smoother texture.',
      items: ['Lightweight copper peptide serum for face and neck.', 'Supports smoother, firmer-looking skin with daily use.', 'Pairs easily before cream, balm and morning SPF.']
    };
  }

  function applyProductHeroSizing() {
    if (document.querySelector('[data-pdp-live]')) return;
    if (!window.matchMedia('(max-width: 767px)').matches) {
      heroStyles.forEach((style, element) => {
        const variables = [...element.style].filter(name => name.startsWith('--')).map(name => [name, element.style.getPropertyValue(name)]);
        if (style === null) element.removeAttribute('style');
        else element.setAttribute('style', style);
        variables.forEach(([name, value]) => element.style.setProperty(name, value));
      });
      heroStyles.clear();
      return;
    }
    const gallery = document.querySelector('body.ploy-product #MainContent .pp .product-gallery');
    if (!gallery) return;
    const uniformGallery = gallery.hasAttribute('data-koppa-uniform-gallery');
    const galleryHeight = gallery.closest('.kp-protocol') ? 'clamp(300px, 100vw, 400px)' : uniformGallery ? '125vw' : '100vw';
    const stage = gallery.querySelector('.product-gallery__stage');
    const slides = stage ? stage.querySelectorAll('[data-ploy-gallery-slide], .product-gallery__slide, li, figure') : [];
    const media = stage ? stage.querySelectorAll('[data-ploy-gallery-slide] img, [data-ploy-gallery-slide] svg, [data-ploy-gallery-slide] video, [data-ploy-gallery-slide] model-viewer, [data-ploy-gallery-slide] picture') : [];
    [gallery, stage, gallery.querySelector('.product-gallery__viewport'), ...slides, ...media, ...gallery.querySelectorAll('[data-ploy-gallery-previous], [data-ploy-gallery-next], .koppa-mobile-zoom')].filter(Boolean).forEach(element => {
      if (!heroStyles.has(element)) heroStyles.set(element, element.getAttribute('style'));
    });
    setImportant(gallery, 'display', 'grid');
    setImportant(gallery, 'grid-template-rows', galleryHeight + ' 72px');
    setImportant(gallery, 'grid-template-columns', 'minmax(0, 1fr)');
    setImportant(gallery, 'height', 'auto');
    setImportant(gallery, 'min-height', '0');
    setImportant(gallery, 'overflow', 'visible');
    setImportant(stage, 'display', 'block');
    setImportant(stage, 'grid-row', '1');
    setImportant(stage, 'grid-column', '1');
    setImportant(stage, 'position', 'relative');
    setImportant(stage, 'width', '100%');
    setImportant(stage, 'height', galleryHeight);
    setImportant(stage, 'min-height', galleryHeight);
    setImportant(stage, 'max-height', uniformGallery ? 'none' : '620px');
    setImportant(stage, 'overflow-x', 'hidden');
    setImportant(stage, 'overflow-y', 'hidden');
    setImportant(stage, 'scroll-snap-type', 'x mandatory');
    setImportant(stage, 'background', 'var(--ploy-background-secondary, #f4f6f8)');
    const viewport = gallery.querySelector('.product-gallery__viewport');
    setImportant(viewport, 'width', '100%');
    setImportant(viewport, 'height', '100%');
    slides.forEach(slide => {
      setImportant(slide, 'flex', '0 0 100%');
      setImportant(slide, 'width', '100%');
      setImportant(slide, 'height', '100%');
      setImportant(slide, 'min-height', '100%');
      setImportant(slide, 'position', 'relative');
      setImportant(slide, 'scroll-snap-align', 'start');
    });
    media.forEach(item => {
      setImportant(item, 'position', item.tagName === 'PICTURE' ? 'static' : 'absolute');
      if (item.tagName !== 'PICTURE') setImportant(item, 'inset', '0');
      setImportant(item, 'width', '100%');
      setImportant(item, 'height', '100%');
      setImportant(item, 'max-width', 'none');
      setImportant(item, 'object-fit', 'contain');
      setImportant(item, 'object-position', 'center center');
    });
    setImportant(stage?.querySelector('[data-ploy-gallery-slide]:first-child img'), 'object-fit', uniformGallery ? 'contain' : 'cover');
    gallery.querySelectorAll('[data-ploy-gallery-previous], [data-ploy-gallery-next]').forEach(button => {
      setImportant(button, 'top', '50%');
      setImportant(button, 'bottom', 'auto');
      setImportant(button, 'transform', 'translateY(-50%)');
      setImportant(button, 'background', 'transparent');
      setImportant(button, 'color', '#fff');
      setImportant(button, 'border', '0');
      setImportant(button, 'box-shadow', 'none');
    });
    document.querySelectorAll('body.ploy-product #MainContent .pp .koppa-mobile-zoom').forEach(button => {
      setImportant(button, 'top', '14px');
      setImportant(button, 'bottom', 'auto');
    });
  }

  function insertMobileBenefits() {
    if (document.querySelector('[data-pdp-live]')) return;
    if (!window.matchMedia('(max-width: 767px)').matches || !document.body.classList.contains('ploy-product')) return;
    if (document.querySelector('.koppa-mobile-benefits-quick')) return;
    const anchor = document.querySelector('#MainContent .pp .product-gallery');
    const copy = productBenefitCopy(productHandle());
    if (!anchor || !copy) return;
    const panel = document.createElement('section');
    panel.className = 'koppa-mobile-benefits-quick';
    panel.setAttribute('aria-label', 'Product benefits');
    panel.innerHTML = `<p class="koppa-mobile-benefits-quick__eyebrow">${copy.name}</p><h2 class="koppa-mobile-benefits-quick__title">${copy.title}</h2><ul class="koppa-mobile-benefits-quick__list">${copy.items.map(item => `<li>${item}</li>`).join('')}</ul>`;
    anchor.parentElement.insertBefore(panel, anchor);
  }

  function addReviewModal() {
    const host = document.querySelector('#product-reviews, #MainContent .product-reviews, #MainContent .trio-reviews') || [...document.querySelectorAll('#MainContent h2, #MainContent [data-ploy-heading="h2"]')].find(element => /customer reviews|customer feedback|our community/i.test(element.textContent || ''))?.closest('section');
    if (!host || host.id === 'koppa-written-reviews' || host.querySelector('.kwr-write, .koppa-write-review-trigger')) return;
    const dialog = document.getElementById('KoppaReviewDialog');
    if (!dialog) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'koppa-write-review-trigger';
    button.textContent = 'Write a Review';
    button.addEventListener('click', () => modalOpen(dialog));
    const insertTarget = host.querySelector(':scope > div, .koppa-container') || host;
    insertTarget.prepend(button);
  }

  function boldProductNames() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    const sections = document.querySelectorAll('#MainContent .pp .product-application, #MainContent .koppa-ugc__inner');
    if (!sections.length) return;
    const names = [
      'GHK-Cu Copper Peptide Serum',
      'GHK-Cu Serum',
      'GHK-Cu Balm Stick',
      'GHK-Cu 2% High Potency Serum',
      'GHK-Cu Advanced Capsule Cream',
      'Advanced Capsule Cream',
      'GHK-Cu Capsule Cream',
      'GHK-Cu Face + Body Balm Stick',
      'Face + Body Balm Stick',
      'Capsule Cream',
      'Balm Stick'
    ];
    sections.forEach(section => {
      const walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          const parent = node.parentElement;
          if (!parent || parent.closest('script, style, strong, b, a, button')) return NodeFilter.FILTER_REJECT;
          return names.some(name => node.nodeValue.includes(name)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        let text = node.nodeValue;
        const fragment = document.createDocumentFragment();
        while (text) {
          const found = names.map(name => ({name, index: text.indexOf(name)})).filter(item => item.index >= 0).sort((a, b) => a.index - b.index || b.name.length - a.name.length)[0];
          if (!found) {
            fragment.append(document.createTextNode(text));
            break;
          }
          if (found.index) fragment.append(document.createTextNode(text.slice(0, found.index)));
          const strong = document.createElement('strong');
          strong.textContent = found.name;
          fragment.append(strong);
          text = text.slice(found.index + found.name.length);
        }
        node.parentNode.replaceChild(fragment, node);
      });
    });
  }

  function cleanProductOrphans() {
    document.querySelectorAll('#MainContent .pp p, #MainContent .pp span, #MainContent .pp div').forEach(node => {
      if (node.children.length) return;
      const text = (node.textContent || '').trim();
      if (/^(practical answers for your moisturising step\.?|practical answers for your moisturizing step\.?|moisturi[sz]ing\.?)$/i.test(text)) node.remove();
    });
  }

  function routineCardLines() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    const cards = [...document.querySelectorAll('#MainContent .pp .related-products a[href*="/products/"]')].filter(card => card.querySelector('img'));
    cards.forEach(card => {
      if (card.querySelector('.koppa-routine-card-line')) return;
      const text = card.textContent || '';
      let line = '';
      if (/serum/i.test(text)) line = 'Lightweight first step for face and neck.';
      else if (/cream|moistur/i.test(text)) line = 'Cushioning hydration after serum.';
      else if (/balm|stick/i.test(text)) line = 'Targeted finish for dry or high-need areas.';
      else if (/protocol|trio/i.test(text)) line = 'All three formulas in routine order.';
      if (!line) return;
      const anchor = card.querySelector('h3, [data-ploy-heading], h2') || card;
      const note = document.createElement('span');
      note.className = 'koppa-routine-card-line';
      note.textContent = line;
      anchor.insertAdjacentElement('afterend', note);
    });
  }

  function menVideoAutoplay() {
    if (!/\/pages\/(men|about)(?:\/|$)/.test(location.pathname) || !window.matchMedia('(max-width: 767px)').matches) return;
    document.querySelectorAll('#MainContent video').forEach(video => {
      if (video.dataset.koppaMobileAutoplay) return;
      video.dataset.koppaMobileAutoplay = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.play?.().catch(() => {});
    });
  }

  function protocolMobileCopy() {
    const isTrio = /\/products\/ghk-cu-trio/.test(location.pathname) || document.querySelector('[data-ploy-product-handle="ghk-cu-trio"]');
    if (!isTrio || !window.matchMedia('(max-width: 767px)').matches) return;
    const title = document.querySelector('#MainContent .pp .koppa-mobile-title');
    if (title && title.textContent !== 'Three formulas, one protocol.') title.textContent = 'Three formulas, one protocol.';
    const overview = document.querySelector('#MainContent .pp .koppa-mobile-overview');
    if (overview && !overview.querySelector('.koppa-protocol-intro')) {
      const intro = document.createElement('p');
      intro.className = 'koppa-protocol-intro';
      intro.textContent = "Your skin doesn\u2019t need 5,000 steps. It needs to be healthy.";
      overview.prepend(intro);
    }
  }

  function shopAllMobileStructure() {
    if (!/\/collections\/shop-all|\/collections\/all/.test(location.pathname) && !document.querySelector('[data-ploy-page="shop-all"]')) return;
    if (!window.matchMedia('(max-width: 767px)').matches) {
      const status = document.querySelector('[data-ploy-page="shop-all"] .collection-products__status');
      const intro = 'All things GHK-Cu. One speciality ingredient, in every formula.';
      if (status && status.textContent !== intro) status.textContent = intro;
      return;
    }
    const grid = document.querySelector('#MainContent [data-ploy-page="shop-all"] .collection-products__rail, #MainContent .collection-products__rail');
    if (!grid) return;
    const heading = document.querySelector('.collection-page .hero [data-ploy-heading="h1"]');
    if (heading && !heading.querySelector('.koppa-shop-title-line') && heading.textContent.trim() === 'Your skin changes. Your routine should keep up.') {
      heading.replaceChildren(...['Your skin changes. ', 'Your routine should keep up.'].map(text => {
        const line = document.createElement('span');
        line.className = 'koppa-shop-title-line';
        line.textContent = text;
        return line;
      }));
    }
    const status = document.querySelector('#MainContent [data-ploy-page="shop-all"] .collection-products__status, #MainContent .collection-products__status');
    const intro = 'Four formulas. Compare the complete Koppā range and choose the format that fits your routine.';
    if (status && status.textContent !== intro) status.textContent = intro;
    const descriptions = {
      'ghk-cu-serum': 'Lightweight daily care for smoother, firmer-looking skin.',
      'ghk-cu-moisturizer': 'Daily moisture for soft, hydrated and comfortable skin.',
      'ghk-cu-balm-stick': 'Targeted moisture for dry areas on face and body.',
      'ghk-cu-trio': 'Serum, cream and balm in one complete daily routine.'
    };
    grid.querySelectorAll('.collection-product-card').forEach(card => {
      if (card.dataset.mobileDetailsReady) return;
      const source = card.querySelector('.collection-product-card__details');
      const link = card.querySelector('a[href*="/products/"]');
      if (!source || !link) return;
      const handle = handleFrom(link);
      card.dataset.mobileDetailsReady = 'loading';
      productData(handle).then(product => {
        if (!card.isConnected) return;
        const details = document.createElement('div');
        details.className = 'koppa-shop-card-mobile';
        const heading = document.createElement('h3');
        const title = document.createElement('a');
        title.href = product.url;
        title.textContent = source.querySelector('[data-ploy-heading]')?.textContent || product.title;
        heading.append(title);
        const description = document.createElement('p');
        description.className = 'koppa-shop-card-description';
        description.textContent = descriptions[handle] || source.querySelector('p')?.textContent || '';
        const price = document.createElement('p');
        price.className = 'koppa-shop-card-price';
        const currency = window.Shopify?.currency?.active || 'USD';
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(product.price / 100);
        const stock = document.createElement('p');
        stock.className = 'koppa-shop-card-stock';
        stock.textContent = window.koppaStockState?.preorders?.[handle] ? window.koppaStockState.labels.preorder : (product.available ? 'In stock' : 'Sold out');
        const action = source.querySelector('a[href*="#product-purchase"]')?.cloneNode(true) || document.createElement('a');
        action.className = 'koppa-shop-card-link';
        action.href = product.url;
        if (window.koppaStockState?.preorders?.[handle]) action.textContent = preorderLabel(handle);
        else if (!action.textContent.trim()) action.textContent = 'View product';
        details.append(heading, description, price, stock, action);
        source.after(details);
        card.dataset.mobileDetailsReady = 'true';
        const plus = card.querySelector('.koppa-quick-add-corner');
        if (plus) {
          plus.title = window.koppaStockState?.preorders?.[handle] ? preorderLabel(handle) : (product.available ? 'Quick add to cart' : 'Join the waitlist');
          plus.setAttribute('aria-label', `${product.available ? 'Quick add' : 'Join waitlist for'} ${product.title}`);
        }
      }).catch(() => { card.dataset.mobileDetailsReady = 'failed'; });
    });
    if (!grid.parentElement.querySelector('.koppa-shop-mobile-statement')) {
      const statement = document.createElement('p');
      statement.className = 'koppa-shop-mobile-statement';
      statement.textContent = 'Start with one formula, or build the full protocol.';
      grid.after(statement);
    }
  }

  function givingBackMobileOrder() {
    if (!/\/pages\/giving-back/.test(location.pathname) || !window.matchMedia('(max-width: 767px)').matches) return;
    const main = document.querySelector('#MainContent main, #MainContent');
    if (!main || main.dataset.koppaGivingBackOrdered) return;
    const sections = [...main.querySelectorAll('section')];
    const hero = sections[0];
    const why = sections.find(section => /why it matters to us/i.test(section.textContent || ''));
    if (hero && why && why !== hero.nextElementSibling) hero.after(why);
    main.dataset.koppaGivingBackOrdered = 'true';
  }

  function ensureMobilePolishStyle() {
    if (document.getElementById('koppa-mobile-polish-live')) return;
    const style = document.createElement('style');
    style.id = 'koppa-mobile-polish-live';
    style.textContent = `
      @media (max-width: 749px) {
        body #MainContent .shopify-section.koppa-home-system #home.hero--carousel { background: var(--ground, oklch(0.986 0.002 255)) !important; }
        body #MainContent .shopify-section.koppa-home-system #products { margin-top: -1px !important; padding-top: 0 !important; }
        body #MainContent .shopify-section.koppa-home-system #products .koppa-section-heading > .module-label:first-child { display: none !important; height: 0 !important; margin: 0 !important; padding: 0 !important; overflow: hidden !important; }
      }
      @media (max-width: 767px) {
        body #MainContent [data-ploy-page="shop-all"] .hero.hero--overlay > div,
        body #MainContent .collection-page .hero.hero--overlay > div { min-height: 0 !important; }
        body #MainContent [data-ploy-page="shop-all"] .hero.hero--overlay img,
        body #MainContent .collection-page .hero.hero--overlay img { object-position: 58% center !important; }
        body #MainContent [data-ploy-page="shop-all"] .hero.hero--overlay > div > .absolute:nth-of-type(1),
        body #MainContent .collection-page .hero.hero--overlay > div > .absolute:nth-of-type(1) { background: linear-gradient(180deg, rgb(3 10 24 / 48%) 0%, rgb(3 10 24 / 62%) 42%, rgb(3 10 24 / 84%) 100%) !important; }
        body #MainContent [data-ploy-page="shop-all"] .hero.hero--overlay .relative.z-10,
        body #MainContent .collection-page .hero.hero--overlay .relative.z-10 { min-height: inherit !important; justify-content: flex-start !important; gap: 24px !important; padding: 42px 20px 28px !important; }
        body #MainContent [data-ploy-page="shop-all"] .hero.hero--overlay .relative.z-10 > div:first-child,
        body #MainContent .collection-page .hero.hero--overlay .relative.z-10 > div:first-child { display: grid !important; gap: 16px !important; }
        body #MainContent [data-ploy-page="shop-all"] .hero.hero--overlay .relative.z-10 > div:first-child :is(p,[data-ploy-heading]),
        body #MainContent .collection-page .hero.hero--overlay .relative.z-10 > div:first-child :is(p,[data-ploy-heading]) { margin: 0 !important; }
        body #MainContent [data-ploy-page="shop-all"] .hero.hero--overlay .relative.z-10 > div:last-child,
        body #MainContent .collection-page .hero.hero--overlay .relative.z-10 > div:last-child { margin-top: 0 !important; }
      }
    `;
    document.head.append(style);
  }

  function applyMobilePolish() {
    ensureMobilePolishStyle();

    if (window.matchMedia('(max-width: 749px)').matches) {
      const homeHero = document.querySelector('#MainContent .shopify-section.koppa-home-system #home.hero--carousel');
      if (homeHero) homeHero.style.setProperty('background', 'var(--ground, oklch(0.986 0.002 255))', 'important');

      document.querySelectorAll('#MainContent .shopify-section.koppa-home-system #products .koppa-section-heading > .module-label:first-child').forEach(label => {
        if (!/The Kopp[aā] Protocol/i.test(label.textContent || '')) return;
        label.style.setProperty('display', 'none', 'important');
        label.style.setProperty('height', '0', 'important');
        label.style.setProperty('margin', '0', 'important');
        label.style.setProperty('padding', '0', 'important');
        label.style.setProperty('overflow', 'hidden', 'important');
      });
    }

    if (window.matchMedia('(max-width: 767px)').matches) {
      const shopHero = document.querySelector('#MainContent [data-ploy-page="shop-all"] .hero.hero--overlay, #MainContent .collection-page .hero.hero--overlay');
      const frame = shopHero && shopHero.firstElementChild;
      const image = shopHero && shopHero.querySelector('img');
      const overlay = frame && frame.querySelector('.absolute:nth-of-type(1)');
      const content = shopHero && shopHero.querySelector('.relative.z-10');
      const copy = content && content.firstElementChild;
      const action = content && content.lastElementChild;

      if (frame) frame.style.setProperty('min-height', '0', 'important');
      if (image) image.style.setProperty('object-position', '58% center', 'important');
      if (overlay) overlay.style.setProperty('background', 'linear-gradient(180deg, rgb(3 10 24 / 48%) 0%, rgb(3 10 24 / 62%) 42%, rgb(3 10 24 / 84%) 100%)', 'important');
      if (content) {
        content.style.setProperty('min-height', '0', 'important');
        content.style.setProperty('justify-content', 'flex-start', 'important');
        content.style.setProperty('gap', '24px', 'important');
        content.style.setProperty('padding', '28px 20px', 'important');
      }
      if (copy) {
        copy.style.setProperty('display', 'grid', 'important');
        copy.style.setProperty('gap', '16px', 'important');
        copy.querySelectorAll('p,[data-ploy-heading]').forEach(node => node.style.setProperty('margin', '0', 'important'));
      }
      if (action) action.style.setProperty('margin-top', '0', 'important');
    }
  }

  function scan() {
    scheduled = false;
    contentObserver.disconnect();
    try {
      addButtons();
      applyProductHeroSizing();
      insertMobileBenefits();
      addReviewModal();
      boldProductNames();
      cleanProductOrphans();
      routineCardLines();
      menVideoAutoplay();
      protocolMobileCopy();
      shopAllMobileStructure();
      givingBackMobileOrder();
      applyMobilePolish();
    } finally {
      // Our own enhancements must not schedule another full-page pass.
      contentObserver.observe(document.querySelector('#MainContent') || document.body, {childList:true, subtree:true});
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.matchMedia('(max-width: 767px)').addEventListener('change', schedule);
  window.addEventListener('resize', () => {
    if (document.querySelector('[data-ploy-page="shop-all"], #products')) schedule();
  }, {passive:true});
  const contentObserver = new MutationObserver(records => {
    // Re-enhance inserted sections/cards, not counters, carousel copy, cart changes,
    // or menu animations. Those already have their own controllers.
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && !node.matches('script,style,svg,path') &&
      (node.matches('section,article,koppa-card,form,picture,img,a[href*="/products/"],.shopify-section,[data-ploy-product]') ||
       node.querySelector('section,article,koppa-card,form,picture,img,a[href*="/products/"]'))
    ))) schedule();
  });
  window.KoppaProductQuickAdd = {scan, applyMobilePolish};
  schedule();
})();


